import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcRequirementStatus } from "server/models"
import { StoreType, addModal } from "client/store"
import {
    Link,
    Default,
    TableColumn,
} from "client/components"

import Edit from "./edit"

const Columns = (
    editAccess: boolean,
) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "100px",
            formatter: (status: CcRequirementStatus) => (
                <>
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editStatus",
                            content: <Edit statusId={status.id} editAccess={editAccess} />,
                        }))}
                    >
                        {status.name}
                    </Link>
                    {status.default && <Default marginLeft />}
                </>
            ),
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
    ]

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
